import { render, staticRenderFns } from "./HomeViewTaskCenterNew.vue?vue&type=template&id=6409e91f&"
import script from "./HomeViewTaskCenterNew.vue?vue&type=script&lang=js&"
export * from "./HomeViewTaskCenterNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports